
import React from 'react'
import classes from './LoadingSpinner.styles'

const LoadingSpinner = () => (
  <div className={classes.spinner}><div/><div/><div/><div/></div>
)

export default LoadingSpinner
